import createSagaMiddleware from "redux-saga";
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from "../src/reducers/rootReducer"; // Corrected import statement
import userSaga from '../src/sagamidalware/userSaga';
import fetchDashboardData from "../src/sagamidalware/DashboardSaga";
import fetchTestDataSaga from "../src/sagamidalware/testSaga";
import subscribersSaga from "../src/sagamidalware/subscribersSaga";
import landingpageSaga from "../src/sagamidalware/landingpageSaga";
import fetchNotificationDataSaga from "./sagamidalware/NotificationSaga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: () => [sagaMiddleware], // Corrected middleware configuration
});

sagaMiddleware.run(userSaga);
sagaMiddleware.run(fetchDashboardData);
sagaMiddleware.run(fetchTestDataSaga);
sagaMiddleware.run(subscribersSaga);
sagaMiddleware.run(landingpageSaga);
sagaMiddleware.run(fetchNotificationDataSaga);
export default store;
